import { render } from "./AboutProgect.vue?vue&type=template&id=75cc2024&scoped=true"
import script from "./AboutProgect.vue?vue&type=script&lang=js"
export * from "./AboutProgect.vue?vue&type=script&lang=js"

import "./AboutProgect.vue?vue&type=style&index=0&id=75cc2024&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cc2024"]])

export default __exports__